module.exports = __webpack_public_path__ + "img/documents_border.6ac2223d.svg";